/**
 * Not found.
 *
 * IT PRINTS THE PATH IT DID NOT MATCH. Every route in this app is either a
 * literal or an id-shaped pattern, so the overwhelmingly likely cause of landing
 * here is a truncated or mistyped identifier pasted out of a chat window — and
 * seeing the path is what tells somebody that. A generic "page not found" hides
 * the one fact that would let them fix it themselves.
 *
 * The links out are the two things a person on this screen actually wants, and
 * nothing else. No search box: there are five screens.
 */
import { Link } from '@/components/app-sidebar'

export function NotFoundPage({ path }: { path: string }) {
  return (
    <div className="min-w-0">
      <h1 className="text-xl font-semibold tracking-tight">Not found</h1>
      <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
        Nothing is routed at <span className="mono">{path}</span>. A session lives at{' '}
        <span className="mono">/sessions/&lt;session id&gt;</span> and an agent at{' '}
        <span className="mono">/agents/&lt;agent id&gt;</span>; if this path came out of a
        message, the identifier may have been cut short on the way.
      </p>
      <p className="mt-3 flex gap-4 text-sm">
        <Link to="/" className="underline underline-offset-4">
          Sessions
        </Link>
        <Link to="/agents" className="underline underline-offset-4">
          Agents
        </Link>
      </p>
    </div>
  )
}
